import{a as m}from"./chunk-PHP3N43R.mjs";import{b as e}from"./chunk-LSZKOVGW.mjs";import{j as o,k as r}from"./chunk-SGUETU3K.mjs";var i=new o({locale:[m,e,r]});export{i as a};
